import { Button, Form } from "devextreme-react";
import { SimpleItem } from "devextreme-react/form";
import { ILookupOptions } from "devextreme-react/lookup";
import notify from "devextreme/ui/notify";
import { forwardRef, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Modal } from "../../../../../components";
import { getApiParams } from "../../../../../redux/auth";
import { BodyType, createRequest } from "../../../../../redux/base/request";
import { getLocalized } from "../../../../../redux/localization";
import { ApiResponse } from "../../../../../types/models/base-model";
import { ProductStatusDto } from "../../../types";

const UpdateProductModal = forwardRef<
  any,
  { status?: ProductStatusDto[]; statusId: number }
>(({ status, statusId }, ref) => {
  const localize = useSelector(getLocalized);
  const { token, lang } = useSelector(getApiParams);
  const [show, setShow] = useState(false);
  const { Id }: { Id: string } = useParams();
  const data = useRef<{ statusId: number; productId: string }>({
    statusId: statusId,
    productId: Id,
  });
  return (
    <>
      <Button
        text={"Durum Güncelle"}
        hint={localize.getString("approved")}
        type="normal"
        icon="edit"
        style={{ marginInlineEnd: 10 }}
        stylingMode="outlined"
        onClick={async () => {
          setShow(true);
        }}
      />
      <Modal
        coverModal={false}
        width={"25%"}
        visible={show}
        onHiding={() => setShow(false)}
        title={"Ürün Durum Güncelle"}
        height={"25%"}
        onSubmitClick={async () => {
          const response: ApiResponse = await createRequest({
            method: "POST",
            url: "api/admin/products/product-status-update",
            bodyType: BodyType.raw,
            token,
            body: data.current,
            lang,
          });
          if (response.Status === 1) {
            notify(response.Message, "success");
            setShow(false);
          } else notify(response.Message, "error");
        }}
      >
        <form>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          ></div>
          <Form
            ref={ref}
            key="Id"
            labelLocation="left"
            formData={data.current}
            showColonAfterLabel={true}
          >
            <SimpleItem
              dataField={"statusId"}
              label={{
                text: "Durum",
              }}
              editorType={"dxLookup"}
              editorOptions={
                {
                  searchEnabled: true,
                  items: status,
                  displayExpr: "Name",
                  valueExpr: "Id",
                } as ILookupOptions
              }
            ></SimpleItem>
          </Form>
        </form>
      </Modal>
    </>
  );
});

export default UpdateProductModal;
